enum LoginWorkflowCodeEnum {
    DASHBOARD = "DASHBOARD",
    DEMO = "DEMO"
}

export default LoginWorkflowCodeEnum;
